import React from 'react'
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Link
} from "react-router-dom";
import Hero from './Hero';
import PortfolioDetail from './PortfolioDetail';

const Routing = () => {
  return (
    <>
    <Router>
        <Routes>
          <Route path="/" element={<Hero />} />
            {/* <Route path="/#portfolio/:desc/" element={<PortfolioDetail />} /> */}
        </Routes>
    </Router>
    </>
  )
}

export default Routing